import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=3b1c0bcf&"
import script from "./iconfont.vue?vue&type=script&lang=js&"
export * from "./iconfont.vue?vue&type=script&lang=js&"
import style0 from "./iconfont.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports